module.exports = __webpack_public_path__ + "static/media/gq.80b56bda.svg";